export default __webpack_public_path__ + "static/media/upiIcon.374a441f.svg";